import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import { ArticleEditPanel } from '@/views/Articles.Details';
import { Button, Space } from 'antd';
import { AdminTabKeys } from '@/views/Admin/AdminTabs';
import { useNavigate } from 'react-router-dom';
import { AddArticleArgs, useAddArticleMutation } from '@/redux/articles';
import { useCallback } from 'react';

export function ArticleAddPage() {
  const { t } = useTranslation();
  const title = t('articles.add');
  const [add] = useAddArticleMutation();
  const push = useNavigate();
  const backRoute = `/admin#${AdminTabKeys['articles']}`;
  const handleAdd = useCallback(
    (value: AddArticleArgs) => {
      add(value);
      push(-1);
    },
    [add, push],
  );
  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#articles">{t('articles.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="article" />}
          color="#814A93"
          actions={
            <Space size="middle">
              <Button onClick={() => push(backRoute)}>{t('cancel')}</Button>
              <Form.Submit uid="article-details" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
        >
          <ArticleEditPanel onSubmit={handleAdd} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
